import amount from "./amount"
import JY from "./JY"

export default{
    amount,
    JY
}